import type {UserAttributeADto} from '@cohort/admin-schemas/userAttributes';
import {Calendar, NumberSquareOne, TextAa, ToggleLeft} from '@phosphor-icons/react';

export const DataTypeIcon: Record<UserAttributeADto['dataType'], JSX.Element> = {
  string: <TextAa size={16} />,
  boolean: <ToggleLeft size={16} />,
  date: <Calendar size={16} />,
  number: <NumberSquareOne size={16} />,
};
